import React, { PureComponent } from 'react';
import NavLink from './NavLink';

const AP_LOGO = require('../../../res/fast-adminportal.png');
export default class AccountLink extends PureComponent {
  render() {
    const { className, style } = this.props;

    return (
      <NavLink
        className={className}
        href="."
        target='_self'
        page={null}
        id="accountLink"
      >
        <img
          alt="adminportal"
          key="admin=portal-logo"
          style={{ width: 160, ...style, paddingRight: 0, marginRight: 20, marginLeft: -2, }}
          className={'fast-scout-name-logo'}
          src={AP_LOGO}/>
        <i className="fa fa-check" aria-hidden="true" style={{ color: 'white', lineHeight: '42px' }}/>
      </NavLink>
    );
  }
}